import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import FavoriteColumnBox from '../../Common/FavoriteColumnBox';
import ShareList from '../../Common/ShareList';
import DownloadComponent from './DownloadComponent';
import DownloadFormComponent from './DownloadFormComponent';
const RightComponent = (props) => {
    const { contents, document, hasFavorite, isGuestUser, loadingFavorite, onClickCopy, onCreateFavorite, onDeleteFavorite, onSubmit, title, } = props;
    const { id, shortUrl } = document;
    return (_jsxs(_Fragment, { children: [isGuestUser ? (_jsx(DownloadFormComponent, { document: document, form: `DownloadFormComponent_${id}`, onSubmit: onSubmit })) : (_jsx(DownloadComponent, { contents: contents, document: document })), _jsxs("div", Object.assign({ className: 'document_right_share' }, { children: [_jsx(ShareList, { onClickClip: onClickCopy, shareUrl: shortUrl, suffix: 'Proffit', title: title }), !isGuestUser && (_jsx(FavoriteColumnBox, { hasFavorite: hasFavorite, loadingFavorite: loadingFavorite, onCreateFavorite: onCreateFavorite, onDeleteFavorite: onDeleteFavorite, value: id }))] }))] }));
};
RightComponent.propTypes = {
    contents: propArrayShape().isRequired,
    document: propShape().isRequired,
    hasFavorite: propBool().isRequired,
    isGuestUser: propBool().isRequired,
    loadingFavorite: propBool().isRequired,
    onClickCopy: propFunc().isRequired,
    onCreateFavorite: propFunc().isRequired,
    onDeleteFavorite: propFunc().isRequired,
    onSubmit: propFunc().isRequired,
    title: propStr().isRequired,
};
export default RightComponent;
